import React, { useEffect } from 'react';
import OnboardingFlow from './onboarding-flow';
import { Toaster } from 'react-hot-toast';
import { useOktaAuth } from "@okta/okta-react";
import { Button } from './@/components/ui/button';
import { Card, CardContent } from './@/components/ui/card';

const Home = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const login = async () => oktaAuth.signInWithRedirect();
  const logout = async () => oktaAuth.signOut();

  const queryString = window.location.search;
  
  useEffect(()=>{
    if(queryString){
      const urlParams = new URLSearchParams(queryString);
      localStorage.setItem("bucket-job-code", '');
      localStorage.setItem("is-analytics", '');
      const lJobCode = urlParams.get('job_code');
      const lIsAnalytics = urlParams.get('is_analytics');
      if(lJobCode){
        localStorage.setItem("bucket-job-code", lJobCode);
      }
      if(lJobCode && lIsAnalytics){
        localStorage.setItem("is-analytics", lIsAnalytics);
      }
    }
  },[queryString]);

  return (
    <>
      <header className="custom-header py-4 d-flex content-center pl-[250px]">
            <img className='main-logo' src="img/logo.png" />
      </header>

      <div>
        {!authState?.isAuthenticated && (
          // <button onClick={login}>Log In</button>
          <div className="min-h-screen bg-black text-white p-8">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl font-bold mb-8 text-center text-yellow-400">
                COSA: Customizable Online Sentiment Analyzer
              </h1>
              <Card className="bg-white text-gray-800">
                <CardContent className="p-6">
                  <div className='text-center my-3'>
                    <Button
                      onClick={login}
                      variant="outline"
                      className=" bg-transparent custom-bg-mbooth text-white border-[0px]"
                    >
                      Login
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        )}

        {authState?.isAuthenticated && (
          <>
            {/* <button onClick={logout}>Log Out</button> */}
            <OnboardingFlow />
            <Toaster position="bottom-right" reverseOrder={false} />
          </>
        )}
      </div>

      
    </>
  );
};

export default Home;
